<template>
  <div>
    <VoterDialog
      :title="voter_dialog_title"
      :sms_authentication="event.sms_authentication"
      :voterProp="voter_dialog_voter"
      v-model="show_voter_dialog"
      :weighted="event.type == 'weighted'"
      :checkEmailDomain="checkEmailDomain"
      @voter-store="voterStore"
      @voter-update="voterUpdate"
      :action="voter_dialog_action"
    ></VoterDialog>
    <AuthorizerList
      :voter="voter_authorizers"
      v-model="show_voter_authorizers"
      :weighted="event.type == 'weighted'"
      :editable="
        event.status != 'completed' &&
        event.status != 'archive' &&
        event.status != 'active'
      "
      @updated="handleAuthorizersUpdated"
    ></AuthorizerList>
    <v-layout row wrap>
      <v-flex md12>
        <v-layout row wrap>
          <v-flex xs12>
            <!-- <v-layout row wrap>
              <h6 class="title font-weight-black mb-3">
                {{ $t('components.eventTabVotersAndCommunication.voters') }}
              </h6>
            </v-layout> -->
            <v-layout
              style="margin-left: -8px"
              mt-3
              mb-5
              row
              wrap
              v-if="
                event.status == 'draft' ||
                (event.manual_reminders && event.status == 'active') ||
                ((event.status != 'active' ||
                  event.adding_voters_in_progress) &&
                  event.status != 'completed' &&
                  event.status != 'archive')
              "
            >
              <v-btn
                @click="resendEmails"
                color="primary"
                small
                v-if="event.manual_reminders && event.status == 'active'"
              >
                <v-icon small>fa-envelope fa-fw</v-icon>&nbsp;{{
                  $t('buttons.resendEmail')
                }}
              </v-btn>
              <v-tooltip
                bottom
                v-if="
                  (event.status != 'active' ||
                    event.adding_voters_in_progress) &&
                  event.status != 'completed' &&
                  event.status != 'archive'
                "
              >
                <v-btn
                  @click="addVoter()"
                  color="primary"
                  slot="activator"
                  small
                >
                  <v-icon small>fa-plus fa-fw</v-icon>&nbsp;
                  {{ $t('buttons.addVoter') }}
                </v-btn>
                <span>{{ $t('tooltips.addVoter') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="event.status == 'draft'">
                <v-btn
                  @click="loadVotersFromAnotherEvent"
                  color="info"
                  slot="activator"
                  small
                  v-if="numberOfOtherEvents > 0"
                >
                  <v-icon small>fa-chart-bar fa-fw</v-icon>&nbsp;{{
                    $t('buttons.loadVoters')
                  }}
                </v-btn>
                <span>{{ $t('tooltips.loadVoters') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="event.status == 'draft'">
                <v-btn
                  @click="importVoters"
                  color="info"
                  slot="activator"
                  small
                >
                  <v-icon small>fa-upload fa-fw</v-icon>&nbsp;{{
                    $t('buttons.importVoters')
                  }}
                </v-btn>
                <span>{{ $t('tooltips.importVoters') }}</span>
              </v-tooltip>
              <input
                @change="fileChange"
                accept=".xlsx"
                ref="fileInput"
                style="display: none"
                type="file"
              />
              <v-tooltip bottom v-if="event.status == 'draft'">
                <v-btn
                  @click="downloadTemplate"
                  color="info"
                  icon
                  slot="activator"
                  small
                >
                  <v-icon small>fa-download</v-icon>
                </v-btn>
                <span>{{ $t('tooltips.downloadTemplate') }}</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-tooltip bottom v-if="event.status == 'draft'">
                <v-btn
                  @click="clearVoters"
                  class="ml-0"
                  color="info"
                  icon
                  slot="activator"
                  small
                >
                  <v-icon small>fa-trash</v-icon>
                </v-btn>
                <span>{{ $t('tooltips.clearVoters') }}</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <v-btn
                  @click="downloadVoters"
                  class="ml-0"
                  color="primary"
                  slot="activator"
                  small
                >
                  <v-icon small>fa-file-excel fa-fw</v-icon>&nbsp;{{
                    $t('buttons.downloadVoters')
                  }}
                </v-btn>
                <span>{{ $t('tooltips.downloadVoters') }}</span>
              </v-tooltip>
              <v-text-field
                :placeholder="$t('fields.search')"
                class="voter-search-field"
                clearable
                hide-details
                outline
                single-line
                v-model="voterSearch"
                @click:clear="$nextTick(() => (voterSearch = ''))"
              ></v-text-field>
            </v-layout>
            <v-layout row wrap>
              <v-flex class="voters-table-container mb-5" xs12>
                <v-data-table
                  :custom-sort="$tableSort"
                  :headers="voterHeaders"
                  :items="voterList"
                  :no-data-text="$t('alerts.noData')"
                  :no-results-text="$t('alerts.noResults')"
                  :rows-per-page-items="[20, 30, 40]"
                  :rows-per-page-text="$t('dataTable.rowsPerPage')"
                  class="elevation-0"
                  must-sort
                >
                  <template slot-scope="props" slot="pageText">
                    {{ $t('dataTable.results') }} {{ props.pageStart }} -
                    {{ props.pageStop }} {{ $t('dataTable.of') }}
                    {{ props.itemsLength }}
                  </template>
                  <template slot-scope="props" slot="items">
                    <tr>
                      <td>{{ props.item.name }}</td>
                      <td>{{ props.item.surname }}</td>
                      <td>{{ props.item.email }}</td>
                      <td>{{ props.item.mobile }}</td>
                      <td>
                        <span v-if="event.type == 'weighted'">{{
                          props.item.weight
                        }}</span>
                      </td>
                      <td>{{ props.item.tags.toString() }}</td>
                      <td>{{ props.item.authorizers.length }}</td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_email_fail_soft"
                        >
                          <v-icon
                            small
                            class="mr-2"
                            color="warning"
                            slot="activator"
                            >fa-envelope
                          </v-icon>
                          <span>{{ $t('labels.emailBounce') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_email_fail_hard"
                        >
                          <v-icon
                            small
                            class="mr-2"
                            color="error"
                            slot="activator"
                            >fa-envelope
                          </v-icon>
                          <span>{{ $t('labels.emailBounce') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_email_sent"
                        >
                          <v-icon small class="mr-2" slot="activator">
                            fa-paper-plane
                          </v-icon>
                          <span>{{ $t('filters.emailSent1') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_email_delivered"
                        >
                          <v-icon small class="mr-2" slot="activator">
                            fa-envelope
                          </v-icon>
                          <span>{{ $t('labels.emailRecieved') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_email_read"
                        >
                          <v-icon small class="mr-2" slot="activator">
                            fa-envelope-open-text
                          </v-icon>
                          <span>{{ $t('labels.emailOpened') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_vote_link_opened"
                        >
                          <v-icon small class="mr-2" slot="activator">
                            fa-hand-pointer
                          </v-icon>
                          <span>{{ $t('labels.linkClicked') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.log_initial_sms_rejected"
                        >
                          <v-icon
                            small
                            class="mr-2"
                            color="warning"
                            slot="activator"
                            >fa-mobile-alt
                          </v-icon>
                          <span>{{ $t('labels.smsBounce') }}</span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-right">
                        <v-tooltip
                          bottom
                          v-if="
                            !props.item.sms_lock &&
                            event.status == 'active' &&
                            event.sms_authentication
                          "
                        >
                          <v-btn color="primary" flat icon slot="activator">
                            <v-icon small>fa-sms</v-icon>
                          </v-btn>
                          <span
                            >{{ props.item.pin_count }}
                            {{ $t('labels.smsSent') }}</span
                          >
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.sms_lock && event.sms_authentication"
                        >
                          <v-btn color="error" flat icon slot="activator">
                            <v-icon small>fa-sms</v-icon>
                          </v-btn>
                          <span
                            >{{ props.item.pin_count }}
                            {{ $t('labels.smsSent') }}</span
                          >
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            props.item.sms_lock == 0 &&
                            props.item.active &&
                            event.status == 'active' &&
                            !props.item.unsubscribed &&
                            !props.item.bounce_lock &&
                            event.manual_reminders
                          "
                        >
                          <v-btn
                            @click="sendEmailVoter(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-envelope</v-icon>
                          </v-btn>
                          <span
                            >{{ $t('buttons.sendEmailVoter') }} ({{
                              $t('labels.alreadySent')
                            }}: {{ props.item.emails_sent }})</span
                          >
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="props.item.active && props.item.unsubscribed"
                        >
                          <v-btn color="primary" flat icon slot="activator">
                            <v-icon small>fa-bell-slash</v-icon>
                          </v-btn>
                          <span
                            >{{ $t('labels.unsubscribed') }} ({{
                              $t('labels.alreadySent')
                            }}: {{ props.item.emails_sent }})</span
                          >
                        </v-tooltip>
                        <v-tooltip bottom>
                          <v-btn
                            @click="openVoterAuthorizers(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-stamp</v-icon>
                          </v-btn>
                          <span>{{ $t('fields.authorizers') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            event.status == 'active' ||
                            event.status == 'completed' ||
                            event.status == 'archive'
                          "
                        >
                          <v-btn
                            @click="showVoterHistory(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-history</v-icon>
                          </v-btn>
                          <span>{{ $t('buttons.voterHistory') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            props.item.active &&
                            event.status != 'active' &&
                            event.status != 'completed' &&
                            event.status != 'archive'
                          "
                        >
                          <v-btn
                            @click="editVoter(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-edit</v-icon>
                          </v-btn>
                          <span>{{ $t('buttons.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            event.status != 'completed' &&
                            event.status != 'archive' &&
                            event.status != 'active'
                          "
                        >
                          <v-btn
                            @click="deleteVoter(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-trash</v-icon>
                          </v-btn>
                          <span>{{ $t('buttons.delete') }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="event.status == 'active' && props.item.active"
                        >
                          <v-btn
                            @click="deactivateVoter(props.item)"
                            color="primary"
                            flat
                            icon
                            slot="activator"
                          >
                            <v-icon small>fa-ban</v-icon>
                          </v-btn>
                          <span>{{ $t('buttons.deactivate') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="!props.item.active">
                          <v-btn color="error" flat icon slot="activator">
                            <v-icon small>fa-ban</v-icon>
                          </v-btn>
                          <span>{{ $t('labels.inactive') }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <template
              v-if="event.status != 'draft' && event.status != 'published'"
            >
              <v-layout mt-1 row wrap>
                <v-spacer></v-spacer>
                <v-btn
                  @click="toggleFilters"
                  color="primary"
                  flat
                  icon
                  slot="activator"
                >
                  <v-icon small>fa-filter</v-icon>
                </v-btn>
              </v-layout>
              <v-layout mt-1 row v-if="filtersExpanded" wrap>
                <v-flex
                  :key="categoryKey"
                  md3
                  sm6
                  v-for="(category, categoryKey) in filters"
                  xs12
                >
                  <div class="title mb-2 mt-3">
                    {{ $t('filters.' + categoryKey) }}
                  </div>
                  <v-checkbox
                    :key="key"
                    :label="$t('filters.' + key)"
                    color="primary"
                    hide-details
                    v-for="(value, key) in filters[categoryKey]"
                    v-model="filters[categoryKey][key]"
                  >
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import VoterDialog, {
  ACTION_CREATE,
  ACTION_EDIT,
} from '@/components/VoterDialog.vue'
import get_file_size from '@/helpers/get_file_size.js'
import handle_validation_error from '@/helpers/handle_validation_error.js'
import handle_session_error from '@/helpers/handle_session_error.js'
import AuthorizerList from '@/components/AuthorizerList.vue'
import Voter from '@/models/Voter.js'
import get_index_by_id from '@/helpers/get_index_by_id.js'
import Authorizer from '@/models/Authorizer.js'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    AuthorizerList,
    VoterDialog,
  },

  props: ['event', 'numberOfOtherEvents', 'publicPath', 'checkEmailDomain'],

  data() {
    return {
      pusherInstance: null,
      show_voter_authorizers: false,
      voter_authorizers: null,
      voter_dialog_title: '',
      voter_dialog_voter: new Voter(),
      voter_dialog_action: ACTION_CREATE,
      show_voter_dialog: false,
      voterSearch: '',
      voterHeaders: [
        { text: this.$t('fields.name'), value: 'name' },
        { text: this.$t('fields.surname'), value: 'surname' },
        { text: this.$t('fields.email'), value: 'email' },
        { text: this.$t('fields.mobile'), value: 'mobile' },
        { text: this.$t('fields.weight'), value: 'weight' },
        { text: this.$t('fields.tags'), value: 'tags' },
        { text: this.$t('fields.authorizers'), value: 'authorizers' },
        { text: '', value: '', sortable: false },
        { text: '', value: '', sortable: false },
      ],
      filters: {
        helpFilter: {
          help: false,
        },
        active: {
          active1: false,
          active0: false,
        },
        sms: {
          sms0: false,
          sms1: false,
          sms2: false,
          sms3: false,
          sms4: false,
        },
        status: {
          emailSent1: false,
          emailSent0: false,
          emailReceived1: false,
          emailReceived0: false,
          emailOpened1: false,
          emailOpened0: false,
          linkOpened1: false,
          linkOpened0: false,
          pinRequested1: false,
          pinRequested0: false,
          pinReceived1: false,
          pinReceived0: false,
          voterOnline1: false,
          voterOnline0: false,
        },
      },
      filtersExpanded: false,
    }
  },

  computed: {
    voterList() {
      let filterTerm = false
      for (let key in this.filters) {
        if (this.filters[key]) {
          filterTerm = true
        }
      }

      if (filterTerm) {
        let voters = []
        for (let voter of this.event.voters) {
          let voterTerm = true

          if (this.voterSearch != '') {
            let stringTerm = false
            if (voter.name.includes(this.voterSearch)) {
              stringTerm = true
            }
            if (voter.surname.includes(this.voterSearch)) {
              stringTerm = true
            }
            if (voter.email.includes(this.voterSearch)) {
              stringTerm = true
            }
            if (voter.mobile.includes(this.voterSearch)) {
              stringTerm = true
            }
            if (voter.tags.includes(this.voterSearch)) {
              stringTerm = true
            }
            if (!stringTerm) {
              voterTerm = false
            }
          }

          let category = 'helpFilter'
          if (this.filters[category].help) {
            if (
              !(
                voter.log_sms_rejected === true ||
                voter.sms_lock ||
                voter.log_initial_email_fail_soft === true ||
                voter.log_initial_email_fail_hard === true
              )
            ) {
              voterTerm = false
            }
          }

          category = 'active'
          if (this.filters[category].active1) {
            if (voter.active !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].active0) {
            if (voter.active === true) {
              voterTerm = false
            }
          }

          category = 'sms'
          if (this.filters[category].sms0) {
            if (voter.pin_count != 0) {
              voterTerm = false
            }
          }
          if (this.filters[category].sms1) {
            if (voter.pin_count != 1) {
              voterTerm = false
            }
          }
          if (this.filters[category].sms2) {
            if (voter.pin_count != 2) {
              voterTerm = false
            }
          }
          if (this.filters[category].sms3) {
            if (voter.pin_count != 3) {
              voterTerm = false
            }
          }
          if (this.filters[category].sms4) {
            if (!voter.sms_lock) {
              voterTerm = false
            }
          }

          category = 'status'
          if (this.filters[category].emailSent1) {
            if (voter.log_initial_email_sent !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].emailSent0) {
            if (voter.log_initial_email_sent === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].emailReceived1) {
            if (voter.log_initial_email_delivered !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].emailReceived0) {
            if (voter.log_initial_email_delivered === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].emailOpened1) {
            if (voter.log_initial_email_read !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].emailOpened0) {
            if (voter.log_initial_email_read === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].linkOpened1) {
            if (voter.log_vote_link_opened !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].linkOpened0) {
            if (voter.log_vote_link_opened === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].pinRequested1) {
            if (voter.log_sms_sent !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].pinRequested0) {
            if (voter.log_sms_sent === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].pinReceived1) {
            if (voter.log_sms_recieved !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].pinReceived0) {
            if (voter.log_sms_recieved === true) {
              voterTerm = false
            }
          }
          if (this.filters[category].voterOnline1) {
            if (voter.online !== true) {
              voterTerm = false
            }
          }
          if (this.filters[category].voterOnline0) {
            if (voter.online === true) {
              voterTerm = false
            }
          }

          if (voterTerm) {
            voters.push(voter)
          }
        }
        return voters
      }
      return this.event.voters
    },

    // Sorts messages from latest to oldest.
    sortedMessages: function () {
      return [...this.event.messages].sort((a, b) => {
        return a.created_at > b.created_at
          ? -1
          : a.created_at < b.created_at
          ? 1
          : 0
      })
    },

    liveMessages: function () {
      return this.sortedMessages.filter(message => {
        return !message.archived
      })
    },

    archivedMessages: function () {
      return this.sortedMessages.filter(message => {
        return message.archived
      })
    },
  },

  methods: {
    handleAuthorizersUpdated(authorizers) {
      const index = get_index_by_id(
        this.event.voters,
        this.voter_authorizers.id
      )

      // Grabs voters.
      const voter = this.event.voters[index]
      // Replaces authorizers.
      voter.authorizers = authorizers
      // Tells Vue that this voter needs changing.
      this.$set(this.event.voters, index, voter)

      this.voter_authorizers = null

      switch (this.event.status) {
        case 'active':
        case 'published':
          this.$emit('event-save', false, null, false)
          break
      }
    },

    openVoterAuthorizers(voter) {
      const voter1 = new Voter(voter)
      voter1.authorizers = voter1.authorizers.map(
        authorizer => new Authorizer(authorizer)
      )

      this.voter_authorizers = voter1
      this.show_voter_authorizers = true
    },

    fileChange() {
      if (this.$refs.fileInput.value === null) {
        return
      }

      // If selected file is larger than 8MB, alert the user and don't upload the file.
      if (get_file_size(this.$refs.fileInput.files[0]) >= 1024 * 8) {
        this.$alert(this.$t('alerts.maxFileSizeLimit'))
        return
      }

      this.$APIUpload(
        this.$refs.fileInput.files[0],
        data => {
          this.$refs.fileInput.value = null

          if (!data.success) {
            this.$alert(this.$t('alerts.invalidImport'))
            return
          }

          let emailEmpty = 0
          let emailDomain = 0
          let emailFail = 0
          let mobileFail = 0
          let imported = 0
          let total = 0
          let duplicates = 0
          let emailDomainVoters = []
          let emailEmptyVoters = []
          let emailFailVoters = []
          let mobileFailVoters = []
          let duplicatesVoters = []

          for (let voter of data.voters) {
            total++

            let newVoter = {
              id: uuidv4(),
              name: voter.name,
              surname: voter.surname,
              email: voter.email.toLowerCase(),
              mobile: voter.mobile,
              active: true,
              tags: voter.tags,
              authorizers: [],
            }

            let term = true

            if (voter.email == '') {
              emailEmpty++
              term = false
              emailEmptyVoters.push(newVoter)
            } else {
              if (!this.$checkEmail(voter.email.toLowerCase())) {
                emailFail++
                term = false
                emailFailVoters.push(newVoter)
              } else {
                if (!this.checkEmailDomain(newVoter.email)) {
                  emailDomain++
                  term = false
                  emailDomainVoters.push(newVoter)
                }
              }
            }

            if (
              voter.mobile != '' &&
              !voter.mobile.match(/^\+386\d{8,9}$/) &&
              !voter.mobile.match(/^\+385\d{8,9}$/) &&
              !voter.mobile.match(/^0\d{8,9}$/)
            ) {
              mobileFail++
              mobileFailVoters.push(newVoter)
              term = false
            }

            for (let voterTemp of this.event.voters) {
              if (voterTemp.active) {
                let duplicated = false

                if (
                  newVoter.email === voterTemp.email.toLowerCase() &&
                  newVoter.email != ''
                ) {
                  term = false

                  if (!duplicated) {
                    duplicates++
                    duplicated = true
                    duplicatesVoters.push(newVoter)
                  }
                }

                if (
                  newVoter.mobile == voterTemp.mobile &&
                  newVoter.mobile != ''
                ) {
                  term = false

                  if (!duplicated) {
                    duplicates++
                    duplicated = true
                    duplicatesVoters.push(newVoter)
                  }
                }
              }
            }

            if (term) {
              imported++
              this.event.voters.push(newVoter)
            }
          }

          let message = this.$t('importLabels.totalRecords') + total + '<br />'
          message +=
            this.$t('importLabels.importedRecords') + imported + '<br />'

          if (emailEmpty != 0) {
            message +=
              '<br />' +
              this.$t('importLabels.emptyEmail') +
              emailEmpty +
              '<br /><table style="width: 100%;">'
            for (let voter of emailEmptyVoters) {
              message +=
                '<tr><td>' +
                voter.name +
                '</td><td>' +
                voter.surname +
                '</td><td>' +
                voter.email.toLowerCase() +
                '</td><td>' +
                voter.mobile +
                '<br />'
            }
            message += '</table>'
          }

          if (emailDomain != 0) {
            message +=
              '<br />' +
              this.$t('importLabels.domainEmail') +
              emailDomain +
              '<br /><table style="width: 100%;">'
            for (let voter of emailDomainVoters) {
              message +=
                '<tr><td>' +
                voter.name +
                '</td><td>' +
                voter.surname +
                '</td><td>' +
                voter.email.toLowerCase() +
                '</td><td>' +
                voter.mobile +
                '<br />'
            }
            message += '</table>'
          }

          if (emailFail != 0) {
            message +=
              '<br />' +
              this.$t('importLabels.failedEmail') +
              emailFail +
              '<br /><table style="width: 100%;">'
            for (let voter of emailFailVoters) {
              message +=
                '<tr><td>' +
                voter.name +
                '</td><td>' +
                voter.surname +
                '</td><td>' +
                voter.email.toLowerCase() +
                '</td><td>' +
                voter.mobile +
                '<br />'
            }
            message += '</table>'
          }

          if (mobileFail != 0) {
            message +=
              '<br />' +
              this.$t('importLabels.failedMobile') +
              mobileFail +
              '<br /><table style="width: 100%;">'
            for (let voter of mobileFailVoters) {
              message +=
                '<tr><td>' +
                voter.name +
                '</td><td>' +
                voter.surname +
                '</td><td>' +
                voter.email.toLowerCase() +
                '</td><td>' +
                voter.mobile +
                '<br />'
            }
            message += '</table>'
          }

          if (duplicates != 0) {
            message +=
              '<br />' +
              this.$t('importLabels.duplicates') +
              duplicates +
              '<br /><table style="width: 100%;">'
            for (let voter of duplicatesVoters) {
              message +=
                '<tr><td>' +
                voter.name +
                '</td><td>' +
                voter.surname +
                '</td><td>' +
                voter.email.toLowerCase() +
                '</td><td>' +
                voter.mobile +
                '<br />'
            }
            message += '</table>'
          }

          this.$alert(message)
        },
        'UPLOAD_VOTERS',
        null,
        error => {
          handle_validation_error(error, this.$alert)
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    toggleFilters() {
      this.filtersExpanded = !this.filtersExpanded
      this.clearFilters()
    },

    clearFilters() {
      for (let categoryKey in this.filters) {
        for (let key in this.filters[categoryKey]) {
          this.filters[categoryKey][key] = false
        }
      }
    },

    importVoters() {
      this.$refs.fileInput.click()
    },

    voterStore(voter) {
      const term =
        this.event.voters
          .filter(voter1 => voter1.active)
          .filter(
            voter1 =>
              voter.email.toLowerCase() === voter1.email.toLowerCase() ||
              (voter.mobile !== '' && voter.mobile === voter1.mobile)
          ).length === 0

      if (!term) {
        this.$alert(this.$t('alerts.voterExists'))

        return
      }

      this.event.voters.push(new Voter(voter))

      switch (this.event.status) {
        case 'active':
          this.$emit('event-save', false, voter.email, false)
          break
        case 'published':
          this.$emit('event-save', false, null, false)
          break
      }

      this.show_voter_dialog = false
    },

    voterUpdate(voter) {
      const term =
        this.event.voters
          .filter(voter1 => voter.id !== voter1.id)
          .filter(voter1 => voter1.active)
          .filter(
            voter1 =>
              voter.email.toLowerCase() === voter1.email.toLowerCase() ||
              (voter.mobile !== '' && voter.mobile === voter1.mobile)
          ).length === 0

      if (!term) {
        this.$alert(this.$t('alerts.voterExists'))

        return
      }

      const voterIndex = get_index_by_id(this.event.voters, voter.id)

      // Replaces the voter.
      this.event.voters.splice(voterIndex, 1, new Voter(voter))

      if (this.event.status == 'active' && voter.unsubscribed !== true) {
        this.$verify(this.$t('alerts.resendSingleQuestion'), result => {
          if (result) {
            this.$emit('event-save', false, voter.email.toLowerCase(), false)
          }
        })
      } else if (this.event.status == 'published') {
        this.$emit('event-save', false, null, false)
      }

      this.show_voter_dialog = false
    },

    resendEmails() {
      this.$verify(this.$t('alerts.resendQuestion'), result => {
        if (result) {
          this.$APICall(
            'post',
            'EVENTS',
            '/resend/' + this.event.id,
            {},
            () => {
              this.$emit('load-event')
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    downloadTemplate() {
      let link = this.publicPath + 'FairVotes_voters_template.xlsx'

      if (this.$i18n.locale == 'hr') {
        link = this.publicPath + 'FairVotes_glasači.xlsx'
      }

      window.open(link)
    },

    sendEmailVoter(voter) {
      if (voter.emails_sent < this.event.max_emails) {
        if (voter.log_voted_hidden !== true) {
          this.$verify(this.$t('alerts.resendSingleQuestion'), result => {
            if (!this.voterSendEmailLock) {
              this.voterSendEmailLock = true

              if (result) {
                this.$emit('event-save', false, voter.email)
                voter.emails_sent++
              } else {
                this.voterSendEmailLock = false
              }
            }
          })
        } else {
          this.$alert(this.$t('alerts.emailVotedError'))
        }
      } else {
        this.$alert(this.$t('alerts.maximumEmailsSent'))
      }
    },

    showVoterHistory(voter) {
      this.$APICall(
        'get',
        'EVENTS',
        '/log/' + this.event.id,
        { voter: voter.id },
        data => {
          let html = ''

          for (let record of data) {
            html += record.time + ' - ' + record.step

            if (record.details != '') {
              html += ' - <i>' + record.details + '</i>'
            }

            html += '<br />'
          }
          this.$alert(html)
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    addVoter() {
      this.voter_dialog_title = this.$t('labels.addVoter')

      this.voter_dialog_voter = new Voter()
      this.voter_dialog_action = ACTION_CREATE

      if (this.event.status == 'active' || this.event.status == 'published') {
        let payload = {
          sms_authentication: this.event.sms_authentication,
          number_of_voters: 1,
        }

        this.$APICall(
          'post',
          'EVENTS',
          '/check-tokens',
          payload,
          data => {
            if (data.success) {
              this.show_voter_dialog = true
            } else {
              this.$alert(this.$t('alerts.tokensNotAvailable'))
            }
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.show_voter_dialog = true
      }
    },

    loadVotersFromAnotherEvent() {
      this.$emit('old-event-load-dialog-reset', 'voters')
      this.$emit('old-event-load-dialog-show', true)
    },

    clearVoters() {
      this.$verify(this.$t('alerts.votersClearQuestion'), result => {
        if (result) {
          this.event.voters = []

          if (this.event.id != 0) {
            this.$emit('event-save', false, null, false)
          }
        }
      })
    },

    editVoter(voter) {
      this.voter_dialog_title = this.$t('labels.editVoter')

      this.voter_dialog_voter = new Voter(voter)
      this.voter_dialog_action = ACTION_EDIT

      this.show_voter_dialog = true
    },

    deleteVoter(voter) {
      const index = get_index_by_id(this.event.voters, voter.id)

      this.$verify(this.$t('alerts.voterDeletionQuestion'), result => {
        if (result) {
          this.event.voters.splice(index, 1)

          if (this.event.id != 0) {
            this.$emit('event-save', false, null, false)
          }
        }
      })
    },

    deactivateVoter(voter) {
      this.$verify(this.$t('alerts.voterDeactivationQuestion'), result => {
        if (result) {
          this.$APICall(
            'post',
            'EVENTS',
            '/deactivate-voter',
            voter,
            data => {
              if (!data.success) {
                this.$alert(this.$t('alerts.deactivationVoterVoted'))
              } else {
                voter.active = false
              }
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    downloadVoters() {
      if (this.voterList.length > 0) {
        this.$APICall(
          'post',
          'EXCEL',
          '/voters',
          this.voterList,
          data => {
            window.open(data.link)
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(this.$t('alerts.excelNoVoters'))
      }
    },
  },
}
</script>

<style scoped>
.voters-table-container {
  border: 2px solid #e8e8e8 !important;
}

::v-deep .voter-search-field {
  max-width: 300px !important;
}

::v-deep .voter-search-field input {
  margin: 0px !important;
}

::v-deep .v-input.voter-search-field .v-input__slot {
  min-height: 0px;
  height: 30px;
  margin-top: 6px;
}

::v-deep .v-input.voter-search-field .v-input__slot .v-input__append-inner {
  margin-top: 0px;
}

::v-deep .v-input.voter-search-field .v-input__slot .v-input__append-inner i {
  font-size: 18px;
}
</style>
